import { CardShell, GameweekGrid, PlayerHeader, TitleBar } from './card-chrome';
import type { Player } from '@api-service/players';
import type { StatRow } from '@lib/article-blocks/stats';
import type { GameweekWindowEntry } from '@lib/article-blocks/types';

type PlayerProfileCardProps = {
  player: Player;
  stats: StatRow[];
  rangeLabel: string;
  upcoming: GameweekWindowEntry[];
};

const StatColumn = ({ rows }: { rows: StatRow[] }) => (
  <dl className="m-0 flex flex-col">
    {rows.map((row) => (
      <div
        key={row.label}
        className="flex items-center justify-between gap-3 border-b border-white/40 py-2"
      >
        <dt className="truncate text-sm text-[#a5aaad] sm:text-base">
          {row.label}
        </dt>
        <dd className="m-0 text-base font-black text-white sm:text-lg">
          {row.value}
        </dd>
      </div>
    ))}
  </dl>
);

export const PlayerProfileCard = ({
  player,
  stats,
  rangeLabel,
  upcoming
}: PlayerProfileCardProps) => {
  const half = Math.ceil(stats.length / 2);
  return (
    <CardShell testId="player-profile-card">
      <PlayerHeader player={player} />
      {upcoming.length > 0 && <GameweekGrid gameweeks={upcoming} isCompact />}
      <TitleBar title="Player profile" detail={rangeLabel} />
      <div className="grid grid-cols-1 gap-x-8 sm:grid-cols-2">
        <StatColumn rows={stats.slice(0, half)} />
        <StatColumn rows={stats.slice(half)} />
      </div>
    </CardShell>
  );
};
